import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { UWRequirementActionEvent, UWRequirementTableData } from '@Underwriting/models';

import { UWRequirementTableActions, UWRequirementTableProps } from '../uw-requirements-expand-table';
import { IntegrationEnum } from '@Enums';
import { NgIf } from '@angular/common';
import { MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/list';
import { UWRequirementsActionsItemDocumentComponent } from '../uw-requirements-actions-item-documents';
import { UWRequirementsActionsItemAgentCommunicationsComponent } from '../uw-requirements-actions-item-agent-communications/uw-requirements-actions-item-agent-communications.component';
import { SharedModule } from '@Shared/shared.module';


@Component({
    selector: 'uw-requirements-actions-received',
    templateUrl: './uw-requirements-actions-received.component.html',
    styleUrls: ['./uw-requirements-actions-received.component.scss'],
    imports: [
        SharedModule,
        forwardRef(() => UWRequirementsActionsItemDocumentComponent),
        forwardRef(() => UWRequirementsActionsItemAgentCommunicationsComponent)
    ],
})
export default class UWRequirementsActionsReceivedComponent {
    @Input() caseRequirement: UWRequirementTableData;
    @Input() props: UWRequirementTableProps;
    @Output() onMenuAction = new EventEmitter<UWRequirementActionEvent>();

    canCancel: boolean = false;
    canWaive: boolean = false;

    public get UWRequirementTableActions() {
        return UWRequirementTableActions;
    }

    public get CanCancel(): boolean {
        return this.caseRequirement.integrationId !== this.IntegrationEnum.ParamedsAps && this.caseRequirement.integrationId !== this.IntegrationEnum.HealthIntelligence && this.caseRequirement.integrationId !== this.IntegrationEnum.Apps;
    }

    public get CanWaive(): boolean {
        return this.caseRequirement.integrationId !== this.IntegrationEnum.ParamedsAps && this.caseRequirement.integrationId !== this.IntegrationEnum.HealthIntelligence && this.caseRequirement.integrationId !== this.IntegrationEnum.Apps;
    }

    handleMenuAction(columnAction: UWRequirementTableActions, caseRequirement: UWRequirementTableData) {
        const actionEvent: UWRequirementActionEvent = {
            action: columnAction,
            data: caseRequirement
        };
        this.handleMenuActionEvent(actionEvent);
    }

    handleMenuActionEvent(event: UWRequirementActionEvent) {
        this.onMenuAction.emit(event);
    }

    // Dev Note: We need to expose the enum to allow the html template to use it in a condition.
    public get IntegrationEnum() {
        return IntegrationEnum;
    }
}
